<template>
  <div class="unbuild">
    <img src="../../assets/image/404.jpg"
         alt="">
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
.unbuild {
    background: #fff;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>